import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
// Importing necessary modules for routing in a React application.

import LoginPage from "./pages/Login";
// Importing the login page component.

import PrivateRoute from "./routes/Private-Routes";
// Importing a component for handling private routes.

import PublicRoute from "./routes/Public-Routes";
// Importing a component for handling public routes.

import RegistrationManagemnet from "./pages/RegistartionManagement/Registration-Managemnet";
import InvestorManagementMainPage from "./pages/InvestorManagement";
import Dashboard from "./pages/Dashboard";
import Layout from "./Layout";
import RegistrationDetails from "./pages/RegistartionManagement/RegistrationDetails";
import RestrationManagementPartner from "./pages/RegistartionManagement/RestrationManagementPartner";
import RegistrationPartnerDetails from "./pages/RegistartionManagement/RegistrationPartnerDetails";
import BondManagementMainPage from "./pages/BondManagement/BondManagementMainPage";
import InvestorDetails from "./pages/InvestorManagement/InvestorDetails";
import InvestorManagementPartner from "./pages/InvestorManagement/InvestorManagmentParnter";
import InvestorManagementParnterDetails from "./pages/InvestorManagement/InvestorManagmentPartnerDetails";
import BondListEdit from "./pages/BondManagement/BondListEdit";
import BondAdd from "./pages/BondManagement/BondAdd";
import { useDispatch, useSelector } from "react-redux";
import ReportMain from "./pages/Report/ReportMain";
import InvestorReportEdit from "./pages/Report/InvestorReportEdit";
import UserManagementMain from "./pages/UserManagement/UserManagementMain";
import UserCreation from "./pages/UserManagement/UserCreation";
import AddUserManagement from "./pages/UserManagement/AddUserManagement";
import CmsList from "./pages/CMS/CmsList";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // import css for toastify
import EditUserManagement from "./pages/UserManagement/edituserManagement";
import axios from "axios";
import { addUserPermissionData } from "./redux/userSlice";
import HomePagemanage from "./pages/CMS/HomePage";
import ContactUs from "./pages/CMS/contactUs";
import FaqManage from "./pages/CMS/Faq";
import BlogManage from "./pages/CMS/Blog";
import AboutUsManage from "./pages/CMS/AboutUs";
import AddFaq from "./pages/CMS/Faq/addFaq";
import EditFaq from "./pages/CMS/Faq/editFaq";
import { addCmsData } from "./redux/cmsSlice";
import Announcement from "./pages/CMS/Announcement";
import RelationshipManagerMain from "./pages/RelationshipManager/RelationshipManagerMain";
import SellRequestMain from "./pages/SellRequest/SellRequest";
import InviteWealthPartner from "./pages/InviteWP";
import ManageClientMainPage from "./pages/ManageClient";
import ManageResourceMainPage from "./pages/ManageResounces";
import FounderNotePage from "./pages/CMS/FIDCms/FounderNoteEditor";
import FaqCategoriesPage from "./pages/CMS/FIDCms/FaqCategories";
import FaqsPage from "./pages/CMS/FIDCms/Faqs";
import AboutSectionsPage from "./pages/CMS/FIDCms/AboutSections";
import HandbookAssetsListPage from "./pages/ManageResounces/Training/Handbook/HandbookAssetList";
import LearningVideoPlaylistPage from "./pages/ManageResounces/Training/LearningVideoAsset";
import LearningVideoViewPlaylist from "./pages/ManageResounces/Training/LearningVideoAsset/LearningVideoViewPlaylist";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;
// Importing the Registration Management page component.

// The main App component
function App() {
  const dispatch = useDispatch();
  const { authToken, isAuthenticated } = useSelector((state) => state.login);
  // Temporary boolean to represent authentication status.
  // This should be replaced with actual authentication logic.

  const getPermission = async () => {
    const endpoint = `${base_url}/${api_type}/permissionsData`;

    try {
      const permissionResponse = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });
      dispatch(
        addUserPermissionData(permissionResponse?.data?.data?.permissions)
      );
      console.log("permissionResponse", permissionResponse);
    } catch (error) {
      console.log("permissionResponse error", error);
    }
  };
  const getCmsData = async () => {
    const endpoint = `${base_url}/${api_type}/cms/homeContent/get`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      dispatch(addCmsData(response?.data?.data));
      console.log("response cms", response);

      // setCmsData()
    } catch (err) {
      console.error("Failed to fetch bond details:", err);
    }
  };

  useEffect(() => {
    if (isAuthenticated || authToken) {
      getPermission();
      getCmsData();
    }
  }, [isAuthenticated, authToken]);

  return (
    <>
      <ToastContainer />
      <Router>
        {/* Defines the application's routing structure */}
        <Routes>
          {/* Public Routes */}
          <Route
            path="/"
            element={
              <PublicRoute isAuthenticated={isAuthenticated}>
                <LoginPage />
                {/* Public route rendering the LoginPage component */}
              </PublicRoute>
            }
          />
          <Route
            path="/login"
            element={
              <PublicRoute isAuthenticated={isAuthenticated}>
                <LoginPage />
              </PublicRoute>
            }
          />
          <Route
            path="/about"
            element={
              <PublicRoute isAuthenticated={isAuthenticated}>
                <h1>About</h1>
                {/* Public route rendering a static About page */}
              </PublicRoute>
            }
          />

          {/* Private Routes */}
          <Route
            path="/registration/investor"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <RegistrationManagemnet />
                {/* Private route rendering the Registration Management component */}
              </PrivateRoute>
            }
          />
          <Route
            path="/registration/wealth-partner"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <RestrationManagementPartner />
                {/* Private route rendering the Registration Management component */}
              </PrivateRoute>
            }
          />
          <Route
            path="/registration/investor/details"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <RegistrationDetails />
                {/* Private route rendering the Registration Management component */}
              </PrivateRoute>
            }
          />
          <Route
            path="/cms/:type"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <CmsList />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/registration/wealth-partner/details"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <RegistrationPartnerDetails />
                {/* Private route rendering the Registration Management component */}
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <Dashboard />
                {/* Private route rendering the Registration Management component */}
              </PrivateRoute>
            }
          />
          <Route
            path="/bond"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <BondManagementMainPage />
                {/* <BondListEdit /> */}
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/bond/edit"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <BondListEdit />
                {/* Private route rendering the Registration Management component */}
              </PrivateRoute>
            }
          />
          <Route
            path="/bond/add"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <BondAdd />
                {/* Private route rendering the Registration Management component */}
              </PrivateRoute>
            }
          />
          <Route
            path="/report"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <ReportMain />
                {/* Private route rendering the Registration Management component */}
              </PrivateRoute>
            }
          />
          <Route
            path="/report/edit"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <InvestorReportEdit />
                {/* Private route rendering the Registration Management component */}
              </PrivateRoute>
            }
          />
          <Route
            path="/user"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <UserManagementMain />
                {/* Private route rendering the Registration Management component */}
              </PrivateRoute>
            }
          />
          <Route
            path="/user/creation"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <UserCreation />
                {/* Private route rendering the Registration Management component */}
              </PrivateRoute>
            }
          />
          <Route
            path="/user/new-user"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <AddUserManagement />
                {/* Private route rendering the Registration Management component */}
              </PrivateRoute>
            }
          />
          <Route
            path="/user/edit-user/:userId"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <EditUserManagement />
                {/* Private route rendering the Registration Management component */}
              </PrivateRoute>
            }
          />
          <Route
            path="/investment-management/investor"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <InvestorManagementMainPage />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/investment-management/investor/details"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <InvestorDetails />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/investment-management/wealth-partner"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <InvestorManagementPartner />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/investment-management/wealth-partner/details"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <InvestorManagementParnterDetails />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/cms/homepage"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <HomePagemanage />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />

          <Route
            path="/cms/contactus"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <ContactUs />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/cms/faq"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <FaqManage />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/cms/add/faq"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <AddFaq />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/cms/edit/faq"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <EditFaq />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/cms/blog"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <BlogManage />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/cms/aboutus"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <AboutUsManage />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/cms/announcement"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <Announcement />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/relationship-manager"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <RelationshipManagerMain />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/sell-request"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <SellRequestMain />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/invite-partner"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <InviteWealthPartner />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/manage-client/:name"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <ManageClientMainPage />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/manage-resource"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <ManageResourceMainPage />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/manage-resource/:id"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <ManageResourceMainPage />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
         
          <Route
            path="/manage-resource/training/learning/:id"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <LearningVideoPlaylistPage />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/manage-resource/training/learning/playlist/:id"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <LearningVideoViewPlaylist />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />
          <Route
            path="/manage-resource/training/handbook/:id"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <HandbookAssetsListPage />
                {/* Private route rendering a static Dashboard page */}
              </PrivateRoute>
            }
          />

          <Route path="/cms/founder-note" element={<FounderNotePage />} />
        <Route path="/cms/faq-categories" element={<FaqCategoriesPage />} />
        <Route path="/cms/faqs" element={<FaqsPage />} />
        <Route path="/cms/about" element={<AboutSectionsPage />} />
         
          
        </Routes>
      </Router>
    </>
  );
}

export default App;
// Exporting the App component as the default export.
